<template>
  <span class="textarea-wrapper">
    <textarea
      v-validate="validateRules"
      :name="name"
      :type="type"
      :value="value"
      :rows="rows"
      :cols="cols"
      :class="{
        'textarea': true,
        'error': errors.has(name)
      }"
      :placeholder="placeholder"
      @input="updateValue($event.target.value)"
    />
    <span v-if="!showServerError">
      <InputErrorBox
        v-show="errors.has(name)"
        :message="errors.first(name)"
      />
    </span>
    <span v-else>
      <InputErrorBox
        v-show="serverError"
        :message="serverError" />
    </span>
  </span>
</template>

<script>
import InputErrorBox from "./ds-input-error-box";

export default {
  name: "DsTextarea",
  inject: ["$validator"],
  components: {
    InputErrorBox
  },
  props: {
    value: {
      type: String,
      default: ""
    },
    name: {
      type: String,
      default: ""
    },
    type: {
      type: String,
      default: "text"
    },
    placeholder: {
      type: String,
      default: ""
    },
    validateRules: {
      type: String | Object,
      default: ""
    },
    serverError: {
      type: String,
      default: null
    },
    showServerError: {
      type: Boolean,
      default: false
    },
    rows: {
      type: String,
      default: "1"
    },
    cols: {
      type: String,
      default: "1"
    }
  },
  methods: {
    updateValue: function(value) {
      this.$emit("input", value);
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../scss/_mixins.scss";
@import "../../scss/_variables.scss";

.textarea {
  border-radius: 5px;
  // border: 1px solid;
  padding: 10px;
  resize: vertical;
  outline: none;
  &:focus,
  &:active {
    border-color: $border-color !important;
    box-shadow: none !important;
  }
}
.textarea.error {
  border: 1px solid $red-error-color;
}
</style>



// WEBPACK FOOTER //
// ../panel-theme/src/js/widgets/ds-textarea.vue